<template>
  <div class="change-assignment-content">
    <div class="change-assignment-content_title">
      {{ $(title) }}
    </div>
    <div class="change-assignment-content_item">
      <div class="change-assignment-content_item-title">
        {{ changeTitle }}
      </div>
      <div class="change-assignment-content_item-text">
        {{ changeContent }}
      </div>
    </div>
    <div class="change-assignment-content_item">
      <div class="change-assignment-content_item-title">
        {{ viewTitle }}
      </div>
      <div class="change-assignment-content_item-text">
        {{ viewContent }}
      </div>
      <LlFileList
        v-if="attaches.length > 0"
        narrow
        two-item
        :attaches="attaches"
        :margin-top="20"
      />
    </div>
    <div class="change-assignment-content_item">
      <div class="change-assignment-content_item-title">
        {{ inputTitle }}
      </div>
      <InputTextareaButton
        :value="value"
        :min-height="90"
        :margin-top="20"
        :placeholder="$t('請填寫評估')"
        @input="$emit('input',$event)"
      />
    </div>
  </div>
</template>
<script>
export default {
  name: "ChangeAssignmentContent",
  props: {
    attaches: {
      type: Array,
      default() {
        return [];
      },
    },
    value: {
      type: String,
      default: "",
    },
    changeTitle: {
      type: String,
      default() {
        return this.$t("變動因素");
      },
    },
    changeContent: {
      type: String,
      default() {
        return this.$t("無");
      },
    },
    viewTitle: {
      type: String,
      default() {
        return this.$t("ESGoal建議應檢視項目");
      },
    },
    viewContent: {
      type: String,
      default() {
        return this.$t("無");
      },
    },
    title: {
      type: String,
      default: "",
    },
    inputTitle: {
      type: String,
      default() {
        return this.$t("寫下我的評估");
      },
    },
  },
};
</script>
<style lang="scss">
@import "@/assets/scss/component/change-assignment-content";
</style>